import styled, { css } from "styled-components";
import theme from "../../../Themes/light";
import InformacoesDaMarca from "./InformacoesDaMarca";
import exp from "constants";
import { ThemeType } from "../../../types/Theme";
import lightTheme from "../../../Themes/lightTheme";

const { colors } = theme;

export const ContainerSugestaoCoresIa = styled.div<{theme: ThemeType}>`
  padding: 8px 2px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .conteudoModalSugestoesCores{
    display: flex;
    gap: 32px;
    align-items: center;

    @media (max-width: 768px) {
      padding: 12px 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
    }

    .sugestoes{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;

      @media (max-width: 768px) {
        gap: 16px;
      }

      .cabecalho{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;

        .titulo{
          color: ${({theme}) => theme.colors.secondary};
        }

        .texto{
          color: ${({theme}) => theme.colors.tertiary};
        }
      }

      .linha{
        height: 1px;
        width: 50%;
        background-color: ${({theme}) => theme.colors.elements};
      }

      .paletasSugeridas{
        display: flex;
        gap: 16px;
        flex-wrap: nowrap;
        justify-content: center;

        .grupoPaletas {
          gap: 16px;
          display: grid;
          grid-template-columns: repeat(2, 190px);
          align-items: center;
          justify-content: center;

          @media (max-width: 768px) {
            grid-template-columns: repeat(2, 160px);
          }
        }

        .paleta{
          padding: 16px 8px;
          background-color: ${({theme}) => theme.colors.background2};
          border: 1px solid ${({theme}) => theme.colors.neutral};
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
          border-radius: 16px;
          width: 192px;

          @media (max-width: 768px) {
            width: 100%;
            padding: 10px;
          }
          &.ativo {
            background: ${(props) => props.theme.colors.borderGradient};
            color: ${(props) => props.theme.colors.primary};
            position: relative;
              &::after {
              content: "";
              position: absolute;
              inset: 1px;
              background: ${(props) => props.theme.colors.background2};
              border-radius: 16px;
              z-index: 0;
            }

            > * {
              position: relative;
              z-index: 1;
              color: ${(props) => props.theme.colors.tertiary};
            }

          }
          .tituloPaleta{
            font-weight: bold;
            color: ${({theme}) => theme.colors.tertiary};
          }

          .cores{
            display: flex;
            align-items: center;
            gap: 8px;

            .cor{
              display: flex;
              flex-direction: column;
              gap: 4px;
              align-items: center;
              color: ${({theme}) => theme.colors.tertiary};

              .bgCor{
                width: 48px;
                height: 16px;
                border-radius: 8px;
              }

              .primaria{
                background-color: #0D5229;  
              }
              .secundaria{
                background-color: #EAEAEA;
              }
            }
          }

          .btnVisualizar{
            padding: 8px 24px;
            color: ${({theme}) => theme.colors.tertiary};
            cursor: pointer;
            background-color: ${({theme}) => theme.colors.white};
            border-radius: 30px;

            &.ativo{
              background-color: ${({theme}) => theme.colors.primary};
              border-radius: 30px;
              color: ${({theme}) => theme.mode === 'light' ? '#fff' : theme.colors.secondary};
            }
          }
        }
      }
      .gerarNovaSugestao{
        color: ${({theme}) => theme.colors.primary};
      }
    }

    .mockup{
      width: 75% !important;
      height: 80%;
    }
  }


  .botoes{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .cancelar{
      cursor: pointer; 
      color: ${({theme}) => theme.colors.primary};
    }
  }
`;

const commonStyles = css`
  display: contents;
  width: 100%;
  .InformacoesDaMarca {
    padding: 5rem 10rem;
    width: 200rem;
    max-width: 90vw;
    display: grid;
    grid-template-columns: calc(60% - 6rem) calc(40% - 6rem);
    gap: 12rem;
    .informacoes {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      min-width: 0;

      .texto-descricao{
        text-align: left;
        padding-bottom: 3rem;
        width: 100%;
        color: ${(props) => props.theme.colors.tertiary};
        position: relative;
      }

      .inputs-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 2rem;
        .select-container,
        .input-container {
          width: 100%;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: wrap;
          column-gap: 2rem;
          row-gap: 2rem;
          flex-wrap: nowrap;
          .whatsapp{
            width: 50%;

            @media (max-width: 768px) {
              width: 100%;
            }
          }

          .insta{
            width: 50%;

            @media (max-width: 768px) {
              width: 100%;
            }
          }

          @media (max-width: 768px) {
            flex-direction: column;
          }
        }
        .perfil-da-marca {
          background-color: ${(props) => props.theme.colors.white};
          border-radius: 3rem;
          width: 100%;
          
          .logo-colors-container {
            display: flex;
            gap: 1rem;
            width: 100%;
            padding: 2rem 3rem;
            align-items: flex-start;
            background-color: ${(props) => props.theme.colors.background};

            .image-upload {
              width: 40%;

              @media (max-width: 768px) {
                width: 30%;
              }
            }

            .colors-section {
              flex: 1;

              @media (max-width: 768px) {
                width: 50%;
              }

              h3 {
                color: ${(props) => props.theme.colors.placeholder};
                margin-bottom: 1.5rem;
                font-weight: 400;
              }
              .cores {
                color: ${(props) => props.theme.colors.tertiary};
                padding-bottom: 2rem;
                text-align: justify;
                font-weight: 400;
              }

              .titulo {
                text-align: center;
                font-weight: bold;
                color: ${({theme}) => theme.colors.secondary};
              }

              .color-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 1.5rem;
                
                .color-label {
                  color: ${(props) => props.theme.colors.tertiary};
                }

                /* O desenho da pílula mora no ColorDisplay. */
              }

              .gerar-descricao-ia {
                width: 100%;
                background: ${(props) => props.theme.colors.borderGradient};
                color: ${(props) => props.theme.colors.primary};
                position: relative;
                font-weight: 500;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 1rem;
                border-radius: 8px;
                padding: 6px 3rem;
                
                 &::after {
                  content: "";
                  position: absolute;
                  inset: 1px;
                  background: ${(props) => props.theme.colors.white};
                  border-radius: 7px;
                  z-index: 0;
                  
                }

                > * {
                  position: relative;
                  z-index: 1;
                  color: ${(props) => props.theme.colors.tertiary};
                }

                .descricao-ia {
                  width: 16px;
                  height: 16px;
                  fill: ${(props) => props.theme.colors.tertiary};
                }
              }
            }
          }
        }
        .quill-wrapper {
          position: relative;
          display: flex;
          justify-content: flex-end;
          align-items: flex-start;
          .lenght-quill {
            position: absolute;
            padding: 10px 10px 0 0;
            color: ${colors.placeholder};
          }
        }
      }
    }

    .mockup-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @media (max-width: 1024px) {
      grid-template-columns: calc(50% - 1.5rem) calc(50% - 1.5rem);
      gap: 2rem;
      padding: 3rem 2rem;
      .informacoes {
        > .titulo {
          margin-bottom: 1rem;
        }
      }
    }
    @media (max-width: 750px) {
      padding: 3rem 2rem;
      grid-template-columns: 100%;
      max-width: 100%;
      gap: 5rem;
      .informacoes {
        gap: 0rem;
      }
    }
  }
`;

export const InformacoesDaMarcaContainer = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles};
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      .InformacoesDaMarca {
        width: 100%;
        max-width: 100%;
        display: flex;
        padding: 0;
        gap: 5rem;
        justify-content: space-evenly;
        align-items: center;
        .informacoes {
          gap: 0rem;
        }
        .mockup-container {
          max-width: 55rem;
        }
        @media (max-width: 1024px) {
          .mockup-container {
            display: none;
          }
          .informacoes {
            padding: 0;
            .tituloContainer {
              .titulo {
                margin-bottom: 5rem;
                padding: 0 0 3rem 0;
                .subtitulo {
                  display: none;
                }
                .barra {
                  display: none;
                }
              }
            }
          }
        }
      }
    `};
  ${({ configIn }) => configIn === "empresa" && css``};
`;